export interface IGetZonesFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
